namespace Gamification.Gamification {
    export namespace UtentiProdottiEsperienzeTaskService {
        export const baseUrl = 'Gamification/UtentiProdottiEsperienzeTask';

        export declare function Create(request: Serenity.SaveRequest<UtentiProdottiEsperienzeTaskRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiProdottiEsperienzeTaskRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiProdottiEsperienzeTaskRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiProdottiEsperienzeTaskRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiProdottiEsperienzeTask/Create",
            Update = "Gamification/UtentiProdottiEsperienzeTask/Update",
            Delete = "Gamification/UtentiProdottiEsperienzeTask/Delete",
            Retrieve = "Gamification/UtentiProdottiEsperienzeTask/Retrieve",
            List = "Gamification/UtentiProdottiEsperienzeTask/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiProdottiEsperienzeTaskService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
